import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Button } from '@grandvisionhq/common';

const AddToCart = (props)=>/*#__PURE__*/ React.createElement(Button, swcHelpers.extends({
        size: "custom",
        "data-t": "add-to-cart",
        className: "add-to-cart"
    }, props))
;

export { AddToCart };
//# sourceMappingURL=AddToCart.js.map
